export const en = {
    'invalid-query':
        'Phrase contains invalid characters. Only letters, numbers, and Yandex.Direct operators may be used.',
    'no-phrases-for-dynamic-campaigns': 'You cannot add keywords to Dynamic campaign ad groups',
    'no-phrases-for-smart-banners':
        "You can't set up a deactivation threshold as there is no payer specified for your account. You can {addPayerLink} and set up the suspension threshold"
};
